import React from 'react';

import OptimizedImage from '../OptimizedImage';

export default ({
  bg,
  img,
  withoutCoreImg,
  staticContent: { title, description, stepNumber }
}) => {
  return (
    <div className={`bg-white ${bg && 'bg'}`}>
      <div className="container">
        <div className="step fourth mt-n2">
          <div className="left-section">
            <div className={`number-border ${!bg && 'removeBg'}`}>
              <div className="number-step">
                <span>{stepNumber}</span>
              </div>
            </div>
          </div>
          <div
            className={`right-section ${img &&
              'stepImg position-relative'} ${withoutCoreImg && 'none'}`}
          >
            <h3 className="tt">{title}</h3>
            <div className="content">
              <div className="row">
                <div className="col-md-6">
                  <p>{description}</p>
                </div>
              </div>
            </div>
            <div className="">
              <OptimizedImage
                src="globe.png"
                className="mg-fluid main-img w-50 position-absolute"
                alt="culture banner"
                title="culture banner"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
